namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem4ExemptColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem4Exempt';
    }
}
